export const ACCESS_TOKEN_KEY: string = '__gqlp_at__';
export const REFRESH_TOKEN_KEY: string = '__gqlp_rt__';
export const ACCESS_TOKEN_EXPIRES: number = 1;
export const REFRESH_TOKEN_EXPIRES: number = 30;
export const TOKENS_DOMAIN: string = window.location.hostname.replace(
  /^[^.]+\./,
  ''
);
export const UA = window.navigator.userAgent;

export const ROLE_ADMIN = 'admin';
export const ROLE_USER = 'user';
export const ROLE_GUEST = '';
